import React from 'react';
import PropTypes from 'prop-types';

import Key from './Key';

function ColumnBpmKey({ width, item, switchKey = true, style }) {
  return (
    <div style={{ width, display: `flex`, flexDirection: `row`, ...style }}>
      <span className={`bpm-key type-placeholder`}>{`${item.bpm} /`}&nbsp;</span>
      { switchKey
        ? <Key simple={item.key} camelot={item.key_camelot} />
        : <span className={`bpm-key type-placeholder`}>{item.key_camelot}</span>
      }
    </div>
  )
}

ColumnBpmKey.propTypes = {
  width: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  switchKey: PropTypes.bool,
  style: PropTypes.object,
}

export default ColumnBpmKey;
